import { useParams } from "react-router";

import { Container } from "@material-ui/core";

import { ContentSection } from "../../../../layout/ContentSection";
import { TitleHeader } from "../../../../components/TitleHeader";
import { LinearProgress } from "../../../../components/LinearProgress";
import { BackButton } from "../../../../components/BackButton";
import { useCustomerComments } from "../../../../comment/comments.hook";
import { ActivitySection } from "../../../../comment/ActivitySection";
import { CustomerCommentList } from "../../../../comment/CustomerCommentList";
import { useAddCustomerComment } from "../../../../comment/add-comment.hook";
import { useTask } from "../../../../task/tasks.hook";
import { NotFoundPage } from "../../../../NotFoundPage";
import { ErrorPage } from "../../../../ErrorPage";
import { CallBeforeInvoiceDebtCollectionTaskContext } from "./CallBeforeInvoiceDebtCollectionTaskContext";
import { useAdministratorAction } from "../../../../workflow/administrator-action.hook";
import { TaskDocument } from "../../../../task/task.model";
import { useDineroContact } from "../../pending-approval/dinero-contacts.hook";

interface CallBeforeInvoiceDebtCollectionDetailPageProps {
    goBack: () => void;
}

export const CallBeforeInvoiceDebtCollectionDetailPage = (props: CallBeforeInvoiceDebtCollectionDetailPageProps) => {
    const { goBack } = props;

    const { taskId } = useParams<{ taskId: string }>();
    const task = useTask(taskId) as TaskDocument | null | undefined;

    const customerId = (() => {
        if ( !task ) return undefined;
        if ( !("customerId" in task) ) return undefined;

        return task.customerId;
    })();

    const contact = useDineroContact(customerId);

    const comments = useCustomerComments(customerId);
    const addComment = useAddCustomerComment(customerId);

    const administratorAction = useAdministratorAction(goBack);

    if ( task === null ) return <NotFoundPage />;
    if ( task === undefined || contact === undefined ) return <LinearProgress />;
    if ( task.type !== "payment-collection" ) return <ErrorPage message="Opgavens type genkendes ikke" />;
    if ( task.status !== "call before debt collection" ) return <ErrorPage message="Opgavens status er uforventet" />;
    if ( contact === null ) return <ErrorPage message="Kundens oplysninger kunne ikke findes" />;

    if ( comments === undefined ) return <LinearProgress />;

    const backButton = <BackButton onClick={goBack} />;

    return (
        <>
            <TitleHeader button={backButton}>Inkasso-advarsel</TitleHeader>
            
            <ContentSection>
                <Container maxWidth="sm" disableGutters>

                    <CallBeforeInvoiceDebtCollectionTaskContext
                        task={task}
                        contact={contact}
                        administratorAction={administratorAction}
                    />

                    <ActivitySection onSave={addComment}>
                        <CustomerCommentList comments={comments} />
                    </ActivitySection>

                </Container>
            </ContentSection>
        </>
    );
};
